/**
 * Shared constants and utility functions for Reports
 */

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Chart colors
export const CHART_COLORS = {
  completed: '#22c55e',  // green
  expired: '#ef4444',    // red
  notCompleted: '#f97316', // orange
  primary: '#2E5E99',
  secondary: '#5A7A9B'
};

// UI colors
export const colors = {
  dark: '#0D2440',
  blue: '#2E5E99',
  gray: '#5A7A9B',
  border: '#C8D8E8',
  bg: '#E7F0FA',
};
